<app-basic-modal>
    <h1 [innerHTML]="data.title"></h1>

    <h2 [innerHTML]="data.subtitle"></h2>

    <p class="text" [innerHTML]="data.copy"></p>

    <div class="question">
        <p>Are you a U.S. healthcare professional?</p>

        <div class="answers">
            <div class="answer blue" [ngClass]="{'selected': yesHcp}" (click)="answer('yes')">Yes</div>
            <div class="answer green" (click)="answer()">No</div>
        </div>
    </div>

    <div class="question">
        <p>From which virtual conference are you linking to us?</p>

        <div class="answers">
            <select name="congress" id="congress" class="custom-select congress" (change)="onSelect($event.target.value)">
                <option value="0" selected disabled>Congress Name</option>
                <option *ngFor="let opt of data.congress_opts" [value]="opt.show" [innerHTML]="opt.show"></option>
            </select>

            <div class="answer green" [ngClass]="{'disabled': congressSelected === '' || !yesHcp}" (click)="onContinue()">Continue</div>
        </div>
    </div>
</app-basic-modal>
